<div class="page" [class.is-compact]="state === 'cancelled' || state === 'request_sent'">

  <!-- Loading state -->
  <div class="card" *ngIf="state === 'loading'">
    <div class="block" style="text-align: center; padding: 60px 32px;">
      <div class="spinner spinner--large"></div>
    </div>
  </div>

  <!-- Error state -->
  <div class="card" *ngIf="state === 'error'">
    <div class="block cancelled">
      <div class="cancelled__icon is-error">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M18 6 6 18"></path><path d="m6 6 12 12"></path>
        </svg>
      </div>
      <h2 class="h2">{{ 'CANCEL.NOT_FOUND_TITLE' | translate }}</h2>
      <p class="lede">{{ 'CANCEL.NOT_FOUND_TEXT' | translate }}</p>
    </div>
  </div>

  <!-- Already cancelled state -->
  <div class="card" *ngIf="state === 'already_cancelled'">
    <header class="card__header" *ngIf="reservation">
      <div class="card__header-left">
        <h1 class="card__brand">{{ reservation.restaurant }}</h1>
        <div class="meta-row">
          <span class="meta">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="5" width="18" height="16" rx="2"/><path d="M3 9h18"/><path d="M8 3v4"/><path d="M16 3v4"/></svg>
            {{ reservation.date }}
          </span>
          <span class="meta">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>
            {{ reservation.time }}
          </span>
          <span class="meta">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="8" r="3.2"/><path d="M2.8 19c.5-3.2 3.1-5 6.2-5s5.7 1.8 6.2 5"/><circle cx="16.5" cy="7" r="2.5"/><path d="M17 14c2.4.2 4 1.7 4.2 4"/></svg>
            {{ reservation.persons }} {{ 'CANCEL.GUESTS_SUFFIX' | translate }}
          </span>
        </div>
      </div>
      <div class="card__header-right">
        <div class="brand-logo"><span class="brand-logo__word">myrest</span></div>
      </div>
    </header>
    <div class="rule"></div>
    <div class="block cancelled">
      <div class="cancelled__icon">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5 10 17 19 7.5"/></svg>
      </div>
      <h2 class="h2">{{ 'CANCEL.ALREADY_CANCELLED_TITLE' | translate }}</h2>
      <p class="lede">{{ 'CANCEL.ALREADY_CANCELLED_TEXT' | translate }}</p>
    </div>
  </div>

  <!-- Past reservation state -->
  <div class="card" *ngIf="state === 'past'">
    <header class="card__header" *ngIf="reservation">
      <div class="card__header-left">
        <h1 class="card__brand">{{ reservation.restaurant }}</h1>
      </div>
      <div class="card__header-right">
        <div class="brand-logo"><span class="brand-logo__word">myrest</span></div>
      </div>
    </header>
    <div class="rule"></div>
    <div class="block cancelled">
      <div class="cancelled__icon is-error">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>
      </div>
      <h2 class="h2">{{ 'CANCEL.PAST_TITLE' | translate }}</h2>
      <p class="lede">{{ 'CANCEL.PAST_TEXT' | translate }}</p>
    </div>
  </div>

  <!-- Already requested (paid) state -->
  <div class="card" *ngIf="state === 'already_requested'">
    <header class="card__header" *ngIf="reservation">
      <div class="card__header-left">
        <h1 class="card__brand">{{ reservation.restaurant }}</h1>
      </div>
      <div class="card__header-right">
        <div class="brand-logo"><span class="brand-logo__word">myrest</span></div>
      </div>
    </header>
    <div class="rule"></div>
    <div class="block cancelled">
      <div class="cancelled__icon is-pending">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 3h12"/><path d="M6 21h12"/><path d="M7 3c0 4 4 5 4 8s-4 4-4 8"/><path d="M17 3c0 4-4 5-4 8s4 4 4 8"/></svg>
      </div>
      <h2 class="h2">{{ 'CANCEL.ALREADY_REQUESTED_TITLE' | translate }}</h2>
      <p class="lede">{{ 'CANCEL.ALREADY_REQUESTED_TEXT' | translate }}</p>
    </div>
  </div>

  <!-- CONFIRM VIEW (free + paid) -->
  <div class="card" *ngIf="state === 'confirm' || state === 'processing'">
    <header class="card__header">
      <div class="card__header-left">
        <h1 class="card__brand">{{ reservation.restaurant }}</h1>
        <div class="meta-row">
          <span class="meta">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="5" width="18" height="16" rx="2"/><path d="M3 9h18"/><path d="M8 3v4"/><path d="M16 3v4"/></svg>
            {{ reservation.date }}
          </span>
          <span class="meta">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>
            {{ reservation.time }}
          </span>
          <span class="meta">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="8" r="3.2"/><path d="M2.8 19c.5-3.2 3.1-5 6.2-5s5.7 1.8 6.2 5"/><circle cx="16.5" cy="7" r="2.5"/><path d="M17 14c2.4.2 4 1.7 4.2 4"/></svg>
            {{ reservation.persons }} {{ 'CANCEL.GUESTS_SUFFIX' | translate }}
          </span>
        </div>
      </div>
      <div class="card__header-right">
        <div class="brand-logo"><span class="brand-logo__word">myrest</span></div>
      </div>
    </header>

    <div class="rule"></div>

    <!-- Title block -->
    <div class="block block--title">
      <!-- Free reservation -->
      <ng-container *ngIf="!reservation.is_paid">
        <div class="alert-pill">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3 2.5 20h19L12 3z"/><path d="M12 10v5"/><circle cx="12" cy="18" r="0.6" fill="currentColor"/></svg>
          <span>{{ 'CANCEL.FREE_PILL' | translate }}</span>
        </div>
        <h2 class="h2">{{ 'CANCEL.FREE_TITLE' | translate }}</h2>
        <p class="lede">{{ 'CANCEL.FREE_TEXT' | translate }}</p>
      </ng-container>

      <!-- Paid reservation -->
      <ng-container *ngIf="reservation.is_paid">
        <div class="alert-pill alert-pill--paid">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="M3 10h18"/><path d="M7 15h4"/></svg>
          <span>{{ 'CANCEL.PAID_PILL' | translate }}</span>
        </div>
        <h2 class="h2">{{ 'CANCEL.PAID_TITLE' | translate }}</h2>
        <div class="notice">
          <div class="notice__icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3 4 6v6c0 4.5 3.4 8 8 9 4.6-1 8-4.5 8-9V6l-8-3z"/><path d="m8.5 12 2.5 2.5L16 10"/></svg>
          </div>
          <div class="notice__body">
            <div class="notice__title">{{ 'CANCEL.PAID_NOTICE_TITLE' | translate }}</div>
            <p class="notice__text" [innerHTML]="'CANCEL.PAID_NOTICE_TEXT1' | translate"></p>
            <p class="notice__text" [innerHTML]="'CANCEL.PAID_NOTICE_TEXT2' | translate"></p>
          </div>
        </div>
      </ng-container>
    </div>

    <!-- Reservation details -->
    <section class="block">
      <h3 class="section-label">{{ 'CANCEL.DETAILS_LABEL' | translate }}</h3>
      <div class="details">
        <div class="detail-row">
          <div class="detail-row__icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9 4.5 5h15L21 9"/><path d="M4 9v10h16V9"/><path d="M3 9c0 1.7 1.3 3 3 3s3-1.3 3-3"/><path d="M9 9c0 1.7 1.3 3 3 3s3-1.3 3-3"/><path d="M15 9c0 1.7 1.3 3 3 3s3-1.3 3-3"/></svg>
          </div>
          <div class="detail-row__label">{{ 'CANCEL.DETAIL_RESTAURANT' | translate }}</div>
          <div class="detail-row__value">{{ reservation.restaurant }}</div>
        </div>
        <div class="detail-row">
          <div class="detail-row__icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="5" width="18" height="16" rx="2"/><path d="M3 9h18"/><path d="M8 3v4"/><path d="M16 3v4"/></svg>
          </div>
          <div class="detail-row__label">{{ 'CANCEL.DETAIL_DATE' | translate }}</div>
          <div class="detail-row__value">{{ reservation.date_long }}</div>
        </div>
        <div class="detail-row">
          <div class="detail-row__icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>
          </div>
          <div class="detail-row__label">{{ 'CANCEL.DETAIL_TIME' | translate }}</div>
          <div class="detail-row__value">{{ reservation.time }}</div>
        </div>
        <div class="detail-row">
          <div class="detail-row__icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="8" r="3.2"/><path d="M2.8 19c.5-3.2 3.1-5 6.2-5s5.7 1.8 6.2 5"/><circle cx="16.5" cy="7" r="2.5"/><path d="M17 14c2.4.2 4 1.7 4.2 4"/></svg>
          </div>
          <div class="detail-row__label">{{ 'CANCEL.DETAIL_PERSONS' | translate }}</div>
          <div class="detail-row__value">{{ reservation.persons }} {{ 'CANCEL.PERSONS_SUFFIX' | translate }}</div>
        </div>
        <div class="detail-row">
          <div class="detail-row__icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="4"/><path d="M4 20c1-4 4.5-6 8-6s7 2 8 6"/></svg>
          </div>
          <div class="detail-row__label">{{ 'CANCEL.DETAIL_NAME' | translate }}</div>
          <div class="detail-row__value">{{ reservation.name?.split(' ')[0] }}</div>
        </div>
        <div class="detail-row">
          <div class="detail-row__icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 9h16"/><path d="M4 15h16"/><path d="M10 3 8 21"/><path d="M16 3l-2 18"/></svg>
          </div>
          <div class="detail-row__label">{{ 'CANCEL.DETAIL_NUMBER' | translate }}</div>
          <div class="detail-row__value is-mono">{{ reservation.id }}</div>
        </div>
        <!-- Payment info for paid reservations -->
        <ng-container *ngIf="reservation.is_paid">
          <div class="detail-row">
            <div class="detail-row__icon">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7c0-1.1.9-2 2-2h13a2 2 0 0 1 2 2v2H5a2 2 0 0 0-2 2V7z"/><path d="M3 9h17a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9z"/><circle cx="17" cy="14" r="1.4" fill="currentColor"/></svg>
            </div>
            <div class="detail-row__label">{{ 'CANCEL.DETAIL_AMOUNT' | translate }}</div>
            <div class="detail-row__value is-amount">{{ reservation.amount }} zł</div>
          </div>
          <div class="detail-row">
            <div class="detail-row__icon">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="M3 10h18"/><path d="M7 15h4"/></svg>
            </div>
            <div class="detail-row__label">{{ 'CANCEL.DETAIL_PAYMENT_STATUS' | translate }}</div>
            <div class="detail-row__value"><span class="pay-pill">{{ 'CANCEL.DETAIL_PAID' | translate }}</span></div>
          </div>
        </ng-container>
      </div>

      <!-- Info callout for paid -->
      <div class="info-callout" *ngIf="reservation.is_paid" [innerHTML]="'CANCEL.PAID_CALLOUT' | translate"></div>
    </section>

    <!-- Actions -->
    <section class="block actions actions--single">
      <button
        class="btn btn--danger btn--solid"
        type="button"
        (click)="cancelReservation()"
        [disabled]="state === 'processing'"
      >
        <ng-container *ngIf="state !== 'processing'">
          {{ (reservation.is_paid ? 'CANCEL.PAID_BUTTON' : 'CANCEL.FREE_BUTTON') | translate }}
        </ng-container>
        <ng-container *ngIf="state === 'processing'">
          <span class="spinner"></span>
          {{ (reservation.is_paid ? 'CANCEL.PAID_LOADING' : 'CANCEL.FREE_LOADING') | translate }}
        </ng-container>
      </button>
    </section>

    <div class="rule" *ngIf="reservation?.phone"></div>
    <footer class="contact" *ngIf="reservation?.phone">
      <div class="contact__icon">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M5 4h4l2 5-2.5 1.5a12 12 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A15 15 0 0 1 3 6a2 2 0 0 1 2-2z"/></svg>
      </div>
      <div class="contact__body">
        <div class="contact__title">{{ 'CANCEL.CONTACT_TITLE' | translate }}</div>
        <div class="contact__text">
          <span [innerHTML]="'CANCEL.CONTACT_TEXT' | translate:{restaurant: reservation.restaurant}"></span>
          <a [href]="'tel:' + reservation.phone" class="contact__phone"> {{ reservation.phone }}</a>.
        </div>
      </div>
    </footer>
  </div>

  <!-- CANCELLED (free) SUCCESS -->
  <div class="card" *ngIf="state === 'cancelled'">
    <header class="card__header">
      <div class="card__header-left">
        <h1 class="card__brand">{{ reservation.restaurant }}</h1>
        <div class="meta-row">
          <span class="meta">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="5" width="18" height="16" rx="2"/><path d="M3 9h18"/><path d="M8 3v4"/><path d="M16 3v4"/></svg>
            {{ reservation.date }}
          </span>
          <span class="meta">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>
            {{ reservation.time }}
          </span>
          <span class="meta">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="8" r="3.2"/><path d="M2.8 19c.5-3.2 3.1-5 6.2-5s5.7 1.8 6.2 5"/><circle cx="16.5" cy="7" r="2.5"/><path d="M17 14c2.4.2 4 1.7 4.2 4"/></svg>
            {{ reservation.persons }} {{ 'CANCEL.GUESTS_SUFFIX' | translate }}
          </span>
        </div>
      </div>
      <div class="card__header-right">
        <div class="brand-logo"><span class="brand-logo__word">myrest</span></div>
      </div>
    </header>
    <div class="rule"></div>
    <section class="block cancelled">
      <div class="cancelled__icon">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5 10 17 19 7.5"/></svg>
      </div>
      <h2 class="h2">{{ 'CANCEL.CANCELLED_TITLE' | translate }}</h2>
      <p class="lede" [innerHTML]="'CANCEL.CANCELLED_TEXT' | translate:{id: reservation.id, restaurant: reservation.restaurant, date: reservation.date_long, time: reservation.time}"></p>
      <div class="receipt">
        <div class="receipt__row">
          <span>{{ 'CANCEL.CANCELLED_NUMBER' | translate }}</span>
          <strong class="is-mono">{{ reservation.id }}</strong>
        </div>
        <div class="receipt__row">
          <span>{{ 'CANCEL.CANCELLED_STATUS' | translate }}</span>
          <strong class="status-pill">{{ 'CANCEL.CANCELLED_STATUS_VALUE' | translate }}</strong>
        </div>
        <div class="receipt__row">
          <span>{{ 'CANCEL.CANCELLED_CONFIRMATION' | translate }}</span>
          <strong>{{ 'CANCEL.CANCELLED_CONFIRMATION_VALUE' | translate }}</strong>
        </div>
      </div>
    </section>
    <div class="rule"></div>
    <footer class="contact" *ngIf="reservation.phone">
      <div class="contact__icon">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M5 4h4l2 5-2.5 1.5a12 12 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A15 15 0 0 1 3 6a2 2 0 0 1 2-2z"/></svg>
      </div>
      <div class="contact__body">
        <div class="contact__title">{{ 'CANCEL.CONTACT_TITLE' | translate }}</div>
        <div class="contact__text">
          <span [innerHTML]="'CANCEL.CONTACT_TEXT' | translate:{restaurant: reservation.restaurant}"></span>
          <a [href]="'tel:' + reservation.phone" class="contact__phone"> {{ reservation.phone }}</a>.
        </div>
      </div>
    </footer>
  </div>

  <!-- REQUEST SENT (paid) SUCCESS -->
  <div class="card" *ngIf="state === 'request_sent'">
    <header class="card__header">
      <div class="card__header-left">
        <h1 class="card__brand">{{ reservation.restaurant }}</h1>
        <div class="meta-row">
          <span class="meta">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="5" width="18" height="16" rx="2"/><path d="M3 9h18"/><path d="M8 3v4"/><path d="M16 3v4"/></svg>
            {{ reservation.date }}
          </span>
          <span class="meta">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>
            {{ reservation.time }}
          </span>
          <span class="meta">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="8" r="3.2"/><path d="M2.8 19c.5-3.2 3.1-5 6.2-5s5.7 1.8 6.2 5"/><circle cx="16.5" cy="7" r="2.5"/><path d="M17 14c2.4.2 4 1.7 4.2 4"/></svg>
            {{ reservation.persons }} {{ 'CANCEL.GUESTS_SUFFIX' | translate }}
          </span>
        </div>
      </div>
      <div class="card__header-right">
        <div class="brand-logo"><span class="brand-logo__word">myrest</span></div>
      </div>
    </header>
    <div class="rule"></div>
    <section class="block cancelled">
      <div class="cancelled__icon is-pending">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 3h12"/><path d="M6 21h12"/><path d="M7 3c0 4 4 5 4 8s-4 4-4 8"/><path d="M17 3c0 4-4 5-4 8s4 4 4 8"/></svg>
      </div>
      <h2 class="h2">{{ 'CANCEL.REQUEST_SENT_TITLE' | translate }}</h2>
      <p class="lede" [innerHTML]="'CANCEL.REQUEST_SENT_TEXT' | translate:{id: reservation.id, restaurant: reservation.restaurant}"></p>
      <p class="lede" style="margin-top: 8px;">{{ 'CANCEL.REQUEST_SENT_SUBTEXT' | translate }}</p>
      <div class="receipt">
        <div class="receipt__row">
          <span>{{ 'CANCEL.CANCELLED_NUMBER' | translate }}</span>
          <strong class="is-mono">{{ reservation.id }}</strong>
        </div>
        <div class="receipt__row">
          <span>{{ 'CANCEL.REQUEST_SENT_STATUS' | translate }}</span>
          <strong class="status-pill status-pill--pending">{{ 'CANCEL.REQUEST_SENT_STATUS_VALUE' | translate }}</strong>
        </div>
        <div class="receipt__row">
          <span>{{ 'CANCEL.REQUEST_SENT_AMOUNT' | translate }}</span>
          <strong>{{ reservation.amount }} zł</strong>
        </div>
        <div class="receipt__row">
          <span>{{ 'CANCEL.CANCELLED_CONFIRMATION' | translate }}</span>
          <strong>{{ 'CANCEL.CANCELLED_CONFIRMATION_VALUE' | translate }}</strong>
        </div>
      </div>
      <div class="next-steps">
        <h4 class="next-steps__title">{{ 'CANCEL.NEXT_STEPS' | translate }}</h4>
        <ol class="next-steps__list">
          <li>
            <span class="next-steps__num">1</span>
            <span [innerHTML]="'CANCEL.NEXT_STEP_1' | translate"></span>
          </li>
          <li>
            <span class="next-steps__num">2</span>
            <span [innerHTML]="'CANCEL.NEXT_STEP_2' | translate"></span>
          </li>
          <li>
            <span class="next-steps__num">3</span>
            <span [innerHTML]="'CANCEL.NEXT_STEP_3' | translate"></span>
          </li>
        </ol>
      </div>
    </section>
    <div class="rule"></div>
    <footer class="contact" *ngIf="reservation.phone">
      <div class="contact__icon">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M5 4h4l2 5-2.5 1.5a12 12 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A15 15 0 0 1 3 6a2 2 0 0 1 2-2z"/></svg>
      </div>
      <div class="contact__body">
        <div class="contact__title">{{ 'CANCEL.CONTACT_TITLE' | translate }}</div>
        <div class="contact__text">
          <span [innerHTML]="'CANCEL.CONTACT_TEXT' | translate:{restaurant: reservation.restaurant}"></span>
          <a [href]="'tel:' + reservation.phone" class="contact__phone"> {{ reservation.phone }}</a>.
        </div>
      </div>
    </footer>
  </div>

  <p class="legal">
    {{ 'CANCEL.LEGAL' | translate }} <span class="legal__brand">myrest</span> · {{ 'CANCEL.LEGAL_SUFFIX' | translate }}
  </p>
</div>
